import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ToTopBtn.css';
import { showUpBtnUpdate } from '../../../redux/actions';
import { PATH } from '../../../constants';

class ToTopBtn extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // -------------------------------------------------------
  // Scroll
  // -------------------------------------------------------

  handleScroll() {
    if (!this.props.detailActive) {
      const showUp = document.documentElement.scrollTop > 200;
      if (showUp !== this.props.showUpBtn) {
        this.props.showUpBtnUpdate(showUp);
      }
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { showUpBtn } = this.props;

    // up style
    const upStyle = {
      pointerEvents: showUpBtn,
      bottom: showUpBtn ? 15 : 0,
      opacity: showUpBtn ? 1 : 0,
      transition: 'opacity 0.2s, bottom 0.2s',
    };

    return (
      <button
        id="btn-up"
        style={upStyle}
        onClick={() => window.scrollTo(0, 0)}
      >
        <img
          src={`${PATH.IMG}ico/ico-up.png`}
          alt="Nahoru"
        />
      </button>
    );
  }
}


const mapStateToProps = state => ({
  detailActive: state.dataDetail.active,
  showUpBtn: state.resize.showUpBtn, // todo - maybe can be just internal state
});

const mapDispatchToProps = dispatch => ({
  showUpBtnUpdate: showUpBtn => dispatch(showUpBtnUpdate(showUpBtn)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToTopBtn);



// WEBPACK FOOTER //
// ./src/components/App/ToTopBtn/ToTopBtn.js